/**
 * Replace the variant segment of a Cloudflare Images delivery URL.
 * CF Images URLs follow: https://imagedelivery.net/<hash>/<id>/<variant>
 * Non-CF URLs pass through unchanged.
 */
function cfVariant(url, variant) {
  if (!url || !url.includes('imagedelivery.net/')) return url;
  return url.replace(/\/[^/]+$/, `/${variant}`);
}

/** Return the 'thumbnail' variant for optimized preview loading. */
export function cfThumbnail(url) {
  return cfVariant(url, 'thumbnail');
}

/** Return the 'public' (full-size) variant for full resolution display. */
export function cfFullImage(url) {
  return cfVariant(url, 'public');
}

/**
 * Is this value safe to hand to <img src>?
 *
 * Only absolute references are. Anything else — a plain sentence, a relative
 * path — gets resolved by the browser against the current page, so a scraped
 * product description sitting in an image column fires a request for
 * `/table/<the whole paragraph>`. The server can't take that: it answers
 * `URIError: Failed to decode param` when the text holds a stray `%`, or
 * `ENAMETOOLONG` when it's simply longer than a filename, once per load and
 * again per retry.
 *
 * Values that fail this check are text, and callers should render them as text.
 */
export function isRenderableImageSrc(value) {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (/^data:image\//i.test(trimmed)) return true;
  try {
    // Protocol-relative URLs (//cdn.example.com/a.jpg) load fine in an <img>,
    // but need a scheme before URL can parse them.
    const { protocol } = new URL(trimmed.startsWith('//') ? `https:${trimmed}` : trimmed);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}
